// @ts-nocheck
import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import {
  Card,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
Typography,
  Grid,
  Tooltip,
  FormControl,
  FormControlLabel,
  Checkbox,
  MenuItem,
  Select,
  Box,
} from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import Table from "../../components/tables/table";
import { useDispatch, useSelector } from "react-redux";
import {
  updateUserStatus,
  updateUserSap,
  userTable,
  getUserCompaniesList,
} from "../../features/auth";
import { FaEye } from "react-icons/fa";

import { useNavigate } from "react-router-dom";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import SoftInput from "../../components/common/softInput";
// import { createNotification } from "../../api/notificationApi";
import { createNewNotification } from "../../features/notification";
import ActionMenu from "../../components/common/custom/action-menu";
import SoftBadge from "../../components/common/softBadge";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
const UserTable = () => {
  const dispatch = useDispatch();
  const { users, status } = useSelector((state: any) => state.auth);
  const [userType, setUserType] = useState("user");
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [openModal, setOpenModal] = useState(false);
  const [sapNumber, setSapNumber] = useState("");
  const [expDate, setExpDate] = useState("");
  const [healthExpDate, setHealthExpDate] = useState("");
  const [selectedUser, setSelectedUser] = useState({});
  const [companyApprovals, setCompanyApprovals] = useState([]);
  const [companiesLoading, setCompaniesLoading] = useState(false);
  // // console.log(data, "data");

  const handleSnpAdd = (user) => {
    setSelectedUser(user);
    setSapNumber(user.sap_no || "");
    setExpDate(user.exp_date ? user.exp_date.slice(0, 10) : "");
    setHealthExpDate(
      user.health_exp_date ? user.health_exp_date.slice(0, 10) : ""
    );
    setCompanyApprovals([]);
    setCompaniesLoading(true);
    setOpenModal(true);

    dispatch(getUserCompaniesList(user._id))
      .unwrap()
      .then((res) => {
        const list = Array.isArray(res?.data) ? res.data : [];
        setCompanyApprovals(
          list.map((c) => ({
            companyCode: c.companyCode,
            companyName: c.companyName || "",
            legalApprove: Boolean(c.legalApprove),
            commercialApprove: Boolean(c.commercialApprove),
          }))
        );
      })
      .catch(() => setCompanyApprovals([]))
      .finally(() => setCompaniesLoading(false));
  };

  const handleStatusChange = async (userId, status) => {
    await dispatch(updateUserStatus({ userId, status }));
    await dispatch(userTable({ page: pageIndex, limit: pageSize, userType }));
  };

  const handleSapSubmit = async () => {
    const allLegal =
      companyApprovals.length > 0 &&
      companyApprovals.every((c) => c.legalApprove);
    const allCommercial =
      companyApprovals.length > 0 &&
      companyApprovals.every((c) => c.commercialApprove);
    await dispatch(
      updateUserSap({
        user_id: selectedUser._id,
        sap_no: sapNumber,
        exp_date: expDate,
        health_exp_date: healthExpDate,
        email: selectedUser.contact_email || selectedUser.email || "",
        legalApprove: allLegal,
        commercialApprove: allCommercial,
        userApprovals: companyApprovals,
      })
    );
    const approvalMessages = [];
    if (allLegal && companyApprovals.length) approvalMessages.push("legal");
    if (allCommercial && companyApprovals.length)
      approvalMessages.push("commercial");
    if (approvalMessages.length) {
      dispatch(
        createNewNotification({
          id: selectedUser._id,
          receiver_id: selectedUser._id,
          title: "Customer Approval Updated",
          message: `Your ${approvalMessages.join(
            " and "
          )} approval has been recorded. Your account is active once the SAP number and all approvals are complete.`,
          type: "0",
        })
      );
    }

    setOpenModal(false);
    setSapNumber("");
    setExpDate("");
    setHealthExpDate("");
    setCompanyApprovals([]);
    await dispatch(userTable({ page: pageIndex, limit: pageSize, userType }));
  };

  let columns;

  if (userType === "admin") {
    columns = [
      {
        header: "ID",
        accessorKey: "id",
        id: "id",
        align: "center",
        cell: (info: any) => <span>{Number(info.getValue())}</span>,
      },
      {
        header: "Name",
        accessorKey: "name",
        id: "name",
        align: "left",
        cell: (info: any) => <strong>{info.getValue()}</strong>,
      },
      {
        header: "Email",
        accessorKey: "email",
        id: "email",
        align: "left",
        cell: (info: any) => <span>{info.getValue()}</span>,
      },
    ];
  } else {
    columns = [
      {
        header: "ID",
        accessorKey: "id",
        id: "id",
        align: "center",
        cell: (info: any) => <span>{Number(info.getValue())}</span>,
      },
      {
        header: "Name",
        accessorKey: "owner_name",
        id: "owner_name",
        align: "left",
        cell: (info: any) => <strong>{info.getValue()}</strong>,
      },
      {
        header: "Email",
        accessorKey: "email",
        id: "email",
        align: "left",
        cell: (info: any) => <span>{info.getValue()}</span>,
      },
      {
        header: "Mobile Number",
        accessorKey: "mobile_number",
        id: "mobile_number",
        align: "left",
        cell: (info: any) => <span>{info.getValue()}</span>,
      },
      {
        header: "Address",
        accessorKey: "national_address",
        id: "national_address",
        align: "left",
        cell: (info: any) => <span>{info.getValue()}</span>,
      },
      {
        header: "Sap no",
        accessorKey: "sap_no",
        id: "sap_no",
        align: "left",
        cell: (info: any) => <span>{info.getValue()}</span>,
      },
      {
        header: "Legal Approval",
        accessorKey: "legalApprove",
        id: "legalApprove",
        align: "left",
        cell: (info: any) => (
          <SoftBadge
            color={info.getValue() ? "success" : "info"}
            variant="gradient"
            badgeContent={info.getValue() ? "Approved" : "Pending"}
          />
        ),
      },
      {
        header: "Commercial Approval",
        accessorKey: "commercialApprove",
        id: "commercialApprove",
        align: "left",
        cell: (info: any) => (
          <SoftBadge
            color={info.getValue() ? "success" : "info"}
            variant="gradient"
            badgeContent={info.getValue() ? "Approved" : "Pending"}
          />
        ),
      },
      {
        header: "Status",
        accessorKey: "status",
        id: "status",
        align: "left",
        cell: (info: any) => (
          <SoftBadge
            color={info.getValue() === "pending" ? "info" : "success"}
            variant="gradient"
            badgeContent={info.getValue()}
          />
        ),
      },
      {
        header: "Actions",
        id: "actions",
        align: "center",
        cell: (info: any) => {
          const user = info.row.original;
          const id = info.row.original._id;

          const status = info.row.original.status;

          return (
            <div>
              <ActionMenu>
                <MenuItem onClick={() => handleSnpAdd(user)}>
                  Update User Details
                </MenuItem>
                {(status === "pending" || status === "approve") && (
                  <MenuItem onClick={() => handleStatusChange(id, "reject")}>
                    Reject User
                  </MenuItem>
                )}
                <MenuItem onClick={() => navigate(`/users/view/${id}`)}>
                  View User
                </MenuItem>
              </ActionMenu>
            </div>
          );
        },
      },
    ];
  }

  useEffect(() => {
    dispatch(userTable({ page: pageIndex, limit: pageSize, userType }));
  }, [dispatch, pageIndex, pageSize, userType]);

  useEffect(() => {
    if (status && users?.data) {
      setData(users.data);
      setTotalRows(users.pagination.total || 0);
    }
  }, [status, users]);
  // // console.log(selectedUser, "selectedUser");

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
            >
              <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
                User Table
              </SoftTypography>
              {/* <select
                name="userType"
                value={userType}
                onChange={(e) => setUserType(e.target.value)}
                style={{
                  padding: "10px",
                  marginRight: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "14px",
                }}
              >
                <option value={"user"}>User</option>
                <option value={"admin"}>Admin</option>
              </select> */}
              <FormControl
                sx={{
                  marginRight: "10px",
                  minWidth: "160px",
                }}
              >
                <Select
                  labelId="user-type-label"
                  id="user-type"
                  value={userType}
                  label="User Type"
                  name="userType"
                  onChange={(e) => setUserType(e.target.value)}
                  IconComponent={KeyboardArrowDownIcon}
                  fullWidth
                  size="small"
                  sx={{
                    padding: "0px 8px !important",
                    height: "40px !important",
                    display: "block !important",
                    ".MuiSelect-select": {
                      padding: "0px 8px !important",
                      height: "40px !important",
                    },
                    ".MuiSelect-nativeInput": {
                      height: "40px !important",
                    },
                    ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                      display: "block !important",
                      fontSize: "1.25rem !important",
                    },
                    ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                      display: "block !important",
                      fontSize: "1.25rem !important",
                    },
                  }}
                >
                  <MenuItem value={"user"} sx={{ marginBottom: "5px" }}>
                    User
                  </MenuItem>
                  <MenuItem value={"admin"}>Admin</MenuItem>
                </Select>
              </FormControl>
            </SoftBox>
            <SoftBox>
              <Table
                columns={columns}
                data={data}
                pageIndex={pageIndex}
                pageSize={pageSize}
                totalRows={totalRows}
                onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              />
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox>

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle style={{ fontSize: "20px", fontWeight: "600" }}>
          Update User Details
        </DialogTitle>

        <DialogContent dividers>
          <SoftBox mb={2}>
            <SoftTypography
              component="label"
              style={{ fontSize: "15px", fontWeight: "500" }}
              variant="caption"
            >
              SAP Number
            </SoftTypography>
            <SoftInput
              autoFocus
              label="SAP Number"
              type="text"
              fullWidth
              value={sapNumber}
              onChange={(e) => setSapNumber(e.target.value)}
              variant="outlined"
            />
          </SoftBox>

          <SoftBox mt={2}>
            <Typography variant="h5" gutterBottom fontWeight="bold">
              Documents
            </Typography>

            <Grid container spacing={3}>
              {/* Commercial Registration */}
              <Grid item xs={12} sm={6} mb={0}>
                <Typography variant="subtitle1" gutterBottom>
                  <strong style={{ fontSize: "16px" }}>
                    Commercial Registration
                  </strong>
                  {selectedUser.fullPaths?.commorcial_registration ? (
                    <Tooltip title="View Document">
                      <IconButton
                        component="a"
                        href={selectedUser.fullPaths.commorcial_registration}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ ml: 1 }}
                        style={{ fontSize: "18px" }}
                      >
                        <FaEye />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <span style={{ marginLeft: 8 }}>N/A</span>
                  )}
                </Typography>
                <SoftBox>
                  <SoftTypography
                    component="label"
                    variant="caption"
                    style={{ fontSize: "15px", fontWeight: "500" }}
                  >
                    Expiration Date
                  </SoftTypography>
                  <SoftInput
                    label="Expiration Date"
                    type="date"
                    fullWidth
                    value={expDate}
                    onChange={(e) => setExpDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </SoftBox>
              </Grid>

              {/* Health License */}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle1" gutterBottom>
                  <strong style={{ fontSize: "16px" }}>Health License</strong>
                  {selectedUser.fullPaths?.helth_licence ? (
                    <Tooltip title="View Document">
                      <IconButton
                        component="a"
                        href={selectedUser.fullPaths.helth_licence}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ ml: 1 }}
                        style={{ fontSize: "18px" }}
                      >
                        <FaEye />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <span style={{ marginLeft: 8 }}>N/A</span>
                  )}
                </Typography>

                <SoftBox>
                  <SoftTypography
                    component="label"
                    variant="caption"
                    style={{ fontSize: "15px", fontWeight: "500" }}
                  >
                    Health Date
                  </SoftTypography>
                  <SoftInput
                    label="Expiration Date"
                    type="date"
                    fullWidth
                    value={healthExpDate}
                    onChange={(e) => setHealthExpDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </SoftBox>
              </Grid>
            </Grid>
          </SoftBox>

          <SoftBox mt={3}>
            <Typography variant="h5" gutterBottom fontWeight="bold">
              Customer Approval
            </Typography>

            {!sapNumber && (
              <Typography
                variant="body2"
                color="warning.main"
                mb={1}
                fontWeight="500"
              >
                Set the SAP number before granting approvals.
              </Typography>
            )}

            {companiesLoading ? (
              <Typography variant="body2" color="text.secondary">
                Loading linked companies...
              </Typography>
            ) : companyApprovals.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                No companies linked to this customer yet. Set the SAP number to
                load the linked companies.
              </Typography>
            ) : (
              companyApprovals.map((c, idx) => (
                <Box
                  key={`${c.companyCode}-${idx}`}
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    p: 2,
                    mb: 2,
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    gutterBottom
                  >
                    {c.companyName || `Company ${c.companyCode}`}{" "}
                    <span style={{ fontWeight: 400, color: "#6b7280" }}>
                      ({c.companyCode})
                    </span>
                  </Typography>

                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={c.legalApprove}
                            disabled={!sapNumber}
                            onChange={(event) => {
                              const updated = [...companyApprovals];
                              updated[idx] = {
                                ...updated[idx],
                                legalApprove: event.target.checked,
                              };
                              setCompanyApprovals(updated);
                            }}
                          />
                        }
                        label="Legal Approval"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={c.commercialApprove}
                            disabled={!sapNumber}
                            onChange={(event) => {
                              const updated = [...companyApprovals];
                              updated[idx] = {
                                ...updated[idx],
                                commercialApprove: event.target.checked,
                              };
                              setCompanyApprovals(updated);
                            }}
                          />
                        }
                        label="Commercial Approval"
                      />
                    </Grid>
                  </Grid>
                </Box>
              ))
            )}

            <Typography variant="caption" display="block" color="text.secondary" mt={1}>
              The account is activated once the SAP number is set and both the
              legal and commercial approvals are granted for every linked
              company. Approval emails are sent to each company's legal and
              commercial contacts.
            </Typography>
          </SoftBox>
        </DialogContent>

        <DialogActions sx={{ py: 2 }}>
          <Button
            onClick={() => setOpenModal(false)}
            className="modal_cancel modal_btn"
          >
            Cancel
          </Button>
          <Button onClick={handleSapSubmit} className="modal_submit modal_btn">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};

export default UserTable;
